<template>
  <div class="container-fluid h-100">
    <div class="content-promo-class" id="content-promo">
      <div
        class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 "
      >
        <div class="col-12">
          <h1 class="participa">
            ¡AVISO IMPORTANTE!
          </h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
          <h1 class="text-left actual pb-2">
            Debido a la situación actual causada por la pandemia y otros
            factores externos a la compañía, la promoción Havoline Te Lleva a
            España se encuentra suspendida hasta nuevo aviso.
          </h1>
          <p class="text-1-promo">
            ¡No te preocupes por tus códigos! Aun siguen vigentes y puedes
            usarlos por beneficios en el club como: Planes de datos, televisión
            prepago y mucho más.
          </p>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
          >
            <div class="pt-4 col-12 col-md-7 col-lg-7 col-xl-7 col-sm-7">
              <button
                class="btn btn-danger btn-block"
                @click="clienteHavoline()"
              >
                Comunicado a clientes Havoline
              </button>
            </div>
            <div class="pt-3 col-12 col-md-7 col-lg-7 col-xl-7 col-sm-7">
              <button class="btn btn-danger btn-block " @click="coljuegos()">
                Comunicado Coljuegos
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    coljuegos() {
      axios
        .get("api/files/active/" + 4)
        .then(res => {
          if (res.data.cod == 0) {
            window.open(res.data.data[0].url, "_blank");
          }
        })
        .catch(error => {
          console.log("ERROR AL CARGAR EL ARCHIVO");
        });
    },
    clienteHavoline() {
      axios
        .get("api/files/active/" + 5)
        .then(res => {
          if (res.data.cod == 0) {
            window.open(res.data.data[0].url, "_blank");
          }
        })
        .catch(error => {
          console.log("ERROR AL CARGAR EL ARCHIVO");
        });
    }
  },
  mounted() {
    this.coljuegos();
    this.clienteHavoline();
  }
};
</script>

<style>
.img-etiqueta {
  width: 100px;
  height: 100px;
}
.participa {
  font-size: 50px;
  font-family: "Gotham-UltraItalic", sans-serif;
  padding-bottom: 4%;
}
.etiqueta {
  font-family: "GothamBookItalic", sans-serif;
}
.small-size {
  font-family: "GothamBookItalic", sans-serif !important;
}
.actual {
  padding-left: 20%;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 29px;
}
.oportunidades {
  font-size: 20px;
  font-family: "GothamBoldItalic", sans-serif;
  margin-bottom: 0rem !important;
}
.text-1-promo {
  text-align: left;
  font-size: 18px;
  margin-bottom: 0rem !important;
  padding-left: 20%;
  font-family: "GothamBookItalic", sans-serif;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.content-promo-class {
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}
#content-promo {
  background-size: cover;
  background-image: url("./../../assets/img/04.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .participa {
    font-size: 40px;
    /* padding-bottom: 4%; */
  }
  .content-promo-class {
    padding-top: 35%;
    padding-bottom: 12%;
    height: 100%;
  }
  .actual {
    padding-left: 0%;
    font-size: 25px;
    text-align: center !important;
  }
  .text-1-promo {
    text-align: center;
    font-size: 20px;
    padding-left: 0%;
  }
}
</style>
